import { AuthLayout } from 'views/layouts'

import LoginMfaContainer from '../../containers/Forms/LoginMfa'

const LoginMfa = () => {
  return (
    <AuthLayout variant="admin">
      <LoginMfaContainer />
    </AuthLayout>
  )
}

export default LoginMfa
